import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import "./App.css";

import { products } from "./data/products";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Products from "./components/Products";
import ShopComingSoon from "./components/ShopComingSoon";
import Contact from "./components/Contact";
import MobileNav from "./components/MobileNav";
import Footer from "./components/Footer";
import ProductModal from "./components/ProductModal";
import BackgroundDecor from "./components/BackgroundDecor";

import BirthdayInvitation from "./components/BirthdayInvitation";
import HeilyInvitation from "./components/HeilyInvitation";

function WebsiteHome() {
  const [selectedProduct, setSelectedProduct] = useState(null);

  return (
    <main>
      <BackgroundDecor />
      <Navbar />
      <Hero />
      <About />
      <Products products={products} onViewImage={setSelectedProduct} />
      <ShopComingSoon />
      <Contact />
      <MobileNav />
      <Footer />

      <ProductModal
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
      />
    </main>
  );
}

function App() {
  const params = new URLSearchParams(window.location.search);
  const invite = params.get("invite");

  if (invite === "eleanor") {
    return <BirthdayInvitation />;
  }

  if (invite === "heily") {
    return <HeilyInvitation />;
  }

  return (
    <Routes>
      <Route path="/" element={<WebsiteHome />} />
      <Route path="/cumpleanioseleanor" element={<BirthdayInvitation />} />
      <Route path="/cumpleaniosheily" element={<HeilyInvitation />} />
      <Route path="*" element={<WebsiteHome />} />
    </Routes>
  );
}

export default App;